<template>
  <v-layout>
    <v-flex xs12>
      <business-trip-imposition-form
        v-model="item"
        @close="close" @save="save" @input="change" />
      <Confirmation :title="confirmation.title"
                      :message="confirmation.message"
                      :buttons="confirmation.buttons"
                      ref="confirmation"
      />
    </v-flex>
  </v-layout>
</template>

<script>
// import Promise from 'promise-polyfill'
import BusinessTripImpositionForm from './BusinessTripImpositionForm'
import Confirmation from '@/components/dialogs/Confirmation'

export default {
  name: 'business-trip-imposition-new',
  components: {
    BusinessTripImpositionForm,
    Confirmation
  },
  data () {
    return {
      modified: false,
      item: {organization: {id: ''}, activation: true, impositionType: 'OFFICE'},
      confirmation: {}
    }
  },
  methods: {
    save () {
      const self = this
      self.$store.dispatch('BusinessTripImposition/save', {item: self.item, vueinstance: self})
        .then(res => {
          self.item = res
          self.$success('Data saved')
          self.modified = false
          self.close()
        })
        .catch(err => self.$error(err))
    },
    close () {
      const self = this
      if (this.modified) {
        self.confirmation = Object.assign({},
          { title: 'Closing add new Business Trip Imposition. Data will not saved.',
            message: 'Are you sure?',
            buttons: [
              {label: 'Yes', handler: () => this.$router.push({name: 'business-trip-imposition'}), color: 'info'},
              {label: 'No', handler: () => { self.$refs.confirmation.close() }, color: 'warning'}
            ]})
        self.$refs.confirmation.show()
      } else {
        this.$router.push({name: 'business-trip-imposition'})
      }
    },
    change () {
      this.modified = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/master/BusinessTripImpositionNew.vue